import get from "lodash/get";

import graphqlToUserModel from "shared/util/graphqlToUserModel";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

/**
 * Convert various types of user data encountered in quickmatch into the
 * standard user model data format.
 * @param {Object} data - the user data
 * @return {Object} a converted user data
 */
export const prepUserData = (data) => {
	if (data.__typename && data.__typename === "StackMatch") {
		return graphqlToUserModel({
			...data.match,
			__stream: data.stream,
		});
	} else if (data.__typename && data.__typename === "Match") {
		return graphqlToUserModel(data);
	} else if (data.data) {
		return data.data;
	} else {
		return data;
	}
};

/**
 * Assemble a dictionary of stack user guides.
 * @param {Object} data - data returned from the okapi call
 * @param {Array} userGuides - a list of user guide names
 * @return {Object} - a dictionary of stack names to booleans
 */
export const getStackTooltipUserGuides = (data, userGuides) => {
	const hasSeenUserGuides = get(data, "user.hasSeenUserGuides") || [];
	const res = {};

	userGuides.forEach((userGuide, i) => {
		res[userGuide.replace(/^STACK_/, "")] = !!hasSeenUserGuides[i];
	});

	return res;
};

/**
 * @param {Number} expirationTimestamp - Unix timestamp.
 * @return {Number} - The expiration in days.
 */
export function formatStacksExpirationTime(expirationTimestamp) {
	const expirationDiffFromTodayInMs = expirationTimestamp - Date.now();
	return Math.ceil(expirationDiffFromTodayInMs / ONE_DAY_IN_MS);
}



// WEBPACK FOOTER //
// ./src/apps/quickmatch/util/helpers.js